export class DashboardLang {

    public static general = {
        deadline: 38,
        servicing: 39,
        humanResources: 42,
        measurementTools: 46,
        problemSolving: 50,
        documentMang: 51,
        customers: 52,
        consultancy: 53,
        academy: 56,
        project: 60,
        audit: 64
    }

    public static dashboard = {
        calendar: 16,
        dashboard: 15,
        deadlineText: 0,
        servicingText: 2,
        humanResourcesText: 3,
        measurementToolsText: 2,
        problemSolvingText: 4,
        documentMangText: 6,
        customersText: 8,
        consultancyText: 9,
        academyText: 11,
        projectText: 13,
        auditText: 'Active Audits'
    }

    

}


export class DashboardCalendarLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            month: lang.general[27],
            week: lang.general[28],
            day: lang.general[29],  
            previous: lang.general[101],
            next: lang.general[102],
            today: lang.general[103],
            start_date: lang.general[120], 
            end_date: lang.general[121], 
            event: lang.general[122], 
            save: lang.general[0], 
            close: lang.general[17], 
        }

    }

    lang() {
        return this.variables;
    }

}